import { Config } from './config';
import { QueryParam } from './query-param';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { map } from 'rxjs/operators';

import {
  AfterViewInit,
  Component,
  OnInit,
  SimpleChanges,
  OnChanges
} from '@angular/core';
import { ApiService } from './services/api.service';
import { Observable } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { ConfigNav } from './configNav';
import { MobileDialogComponent } from './mobile-dialog/mobile-dialog.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnChanges, OnInit, AfterViewInit {
  title = 'globo-app';

  headerProperties: any = {
    'background-color': 'red'
  };

  queryParam!: QueryParam;
  requestObj!: QueryParam;
  type: any;
  logo: any;
  portalName: any;
  gameConfig: Config = {} as Config;
  configNav!: ConfigNav;
  mobileNumber:any;
  mod!: boolean;

  constructor(
    private activatedRoute: ActivatedRoute,
    private apiService: ApiService,
    private router: Router,
  ) { 

    this.configNav = {
      id: 0,
      home: '',
      faq: '',
      about: '',
      tc: '',
      lang: '',
      account: ''
    };
  }
  ngOnChanges(changes: SimpleChanges): void {
    throw new Error('Method not implemented.');
  }

  ngAfterViewInit() { }

  ngOnInit() {

   this.getQueryParam();
  }
  getQueryParam() {
    this.mod = true
    this.queryParam = {} as QueryParam;
    this.queryParam.theme = 1;
    this.queryParam.popup = false;
    this.queryParam.mobileNumber = 0;
    this.queryParam.sub = false;
    this.activatedRoute.queryParams.subscribe(params => {
      if (typeof params['id'] != undefined && params['id'] != null) {
        this.queryParam.id = params['id'];
      }
      if (typeof params['lang'] != undefined && params['lang'] != null) {
        this.queryParam.lang = params['lang'];
      }

      if (typeof params['code'] != undefined && params['code'] != null) {
        this.queryParam.uuid = params['code'];
      }

      if (
        typeof params['categoryid'] != undefined &&
        params['categoryid'] != null
      ) {
        this.queryParam.categoryid = params['categoryid'];
      }
      if (
        typeof params['operator'] != undefined &&
        params['operator'] != null
      ) {
        this.queryParam.operator = params['operator'];
      }
      if (typeof params['biller'] != undefined && params['biller'] != null) {
        this.queryParam.biller = params['biller'];
      }
      if (typeof params['theme'] != undefined && params['theme'] != null) {
        this.queryParam.theme = params['theme'];
      }

  
      
      if (typeof params['msisdn'] != undefined && params['msisdn'] != null) {
        this.queryParam.msisdn = params['msisdn'];
      }
      if (typeof params['country'] != undefined && params['country'] != null) {
        this.queryParam.country = params['country'];
      }
      if (typeof params['cid'] != undefined && params['cid'] != null) {
        this.queryParam.cid = params['cid'];
      }
      if (typeof params['code'] != undefined && params['code'] != null) {
        this.queryParam.code = params['code'];
      }
  

      if (typeof params['msisdn'] != undefined && params['msisdn'] != null) {
        this.queryParam.msisdn = params['msisdn'];
        
      }

      if (typeof params['mode'] != undefined && params['mode'] != null) {
        this.queryParam.mode = params['mode'];
        if(this.queryParam.mode == 'INAPP'){
          this.mod = false;
        }
      }

      if (typeof params['request_ref'] != undefined && params['request_ref'] != null) {
        this.queryParam.request_ref = params['request_ref'];
      }

      if (typeof params['status'] != undefined && params['status'] != null) {
        this.queryParam.status = params['status'];
        if(this.queryParam.status == 'ACTIVE'){
          this.queryParam.sub = true;
        }
      }

      if (typeof params['subscription_id'] != undefined && params['subscription_id'] != null) {
        this.queryParam.subscription_id = params['subscription_id'];
      }

      if (typeof params['operator_name'] != undefined && params['operator_name'] != null) {
        this.queryParam.operator_name = params['operator_name'];
      }


      if (typeof params['service_id'] != undefined && params['service_id'] != null) {
        this.queryParam.serviceId = params['service_id'];
      }

      if (typeof params['serviceid'] != undefined && params['serviceid'] != null) {
        this.queryParam.serviceId = params['serviceid'];
      }

      if (typeof params['serviceId'] != undefined && params['serviceId'] != null) {
        this.queryParam.serviceId = params['serviceId'];
      }

      if (typeof params['serviceName'] != undefined && params['serviceName'] != null) {
        this.queryParam.serviceName = params['serviceName'];
      }

      if (typeof params['product_id'] != undefined && params['product_id'] != null) {
        this.queryParam.product_id = params['product_id'];
      }

      let storageName = this.queryParam.id+this.queryParam.operator+this.queryParam.biller+this.queryParam.lang+this.queryParam.serviceId+this.queryParam.subscription_id+this.queryParam.request_ref+this.queryParam.product_id;


      this.apiService.setItem(storageName);

      if (localStorage.getItem(storageName) === null) {
        localStorage.setItem(storageName, JSON.stringify(this.queryParam));
      }

      this.apiService.setItem(storageName);

   //   if (localStorage.getItem(storageName) === null) {
   //     
     // }
    
    //  localStorage.setItem('globo-portal-app', JSON.stringify(this.queryParam));
    // localStorage.setItem(storageName, JSON.stringify(this.queryParam));
      console.log('Response :', this.queryParam);
      
      

      setTimeout(() => {
        this.getMainData();
          this.getConfigNavData(this.queryParam.lang);
        this.getConfigData(this.queryParam.id, this.queryParam.lang, this.queryParam.theme);
      }, 500);
    });
  }

  getMainData() {
      this.requestObj = JSON.parse(JSON.stringify(this.queryParam));
      if(this.requestObj.lang == 'PT'){
        this.requestObj.lang = 'EN'
      }
     
    this.apiService.getData(this.requestObj).subscribe(
      (response: any) => {
        console.log('response on main page .....', response);
        this.logo = response.logo;
      },
      (err: HttpErrorResponse) => {
        console.log(err);
      }
    );
  }

  getConfigData(data: any, lang: any, theme: any) {
    this.apiService.getConfigData(data, lang, theme).subscribe(
      (response: any) => {
        this.gameConfig = response;
        this.portalName = this.gameConfig.title;

        document.documentElement.style.setProperty('--backgound-primary-color', this.gameConfig.color);

      },
      (err: HttpErrorResponse) => {
        console.log(err);
      }
    );
  }

  getConfigNavData(lang: any) {
    this.apiService.getConfigNav(lang).subscribe(
      (response: any) => {
        this.configNav = response;
       
      },
      (err: HttpErrorResponse) => {
        console.log(err);
      }
    );
  }

}
